export const typeFilters = {
  'INDIVIDUAL': 'Indywiduel',
  'PAIRS': 'Turniej par',
  'TEAMS': 'Turniej teamów'
};

export const rankFilters = {
  'OTP_THREE_STARS': 'OTP***',
  'OTP_TWO_STARS': 'OTP**',
  'OTP_ONE_STAR': 'OTP*',
  'OTP': 'OTP',
  'RTP_ONE_STAR': 'RTP*',
  'RTP': 'RTP',
  'LOCAL': 'Lokalna'
};

export const locationFilters = {
  'DS': 'DS (dolnośląskie)',
  'KP': 'KP (kujawsko-pomorskie)',
  'LU': 'LU (lubelskie)',
  'LB': 'LB (lubuskie)',
  'LD': 'LD (łódzkie)',
  'MP': 'MP (małopolskie)',
  'MA': 'MA (mazowieckie)',
  'OP': 'OP (opolskie)',
  'PK': 'PK (podkarpackie)',
  'PD': 'PD (podlaskie)',
  'PM': 'PM (pomorskie)',
  'SL': 'SL (śląskie)',
  'SW': 'SW (świętokrzyskie)',
  'WM': 'WM (warmińsko-mazurskie)',
  'WP': 'WP (wielkopolskie)',
  'ZP': 'ZP (zachodniopomorskie)'
};

export const sortingModes = {
  'START_TIME_ASCENDING': 'Data rozpoczęcia (od najwcześniejszej)',
  'START_TIME_DESCENDING': 'Data rozpoczęcia (od najpóźniejszej)',
  'REGISTERED_PLAYER_COUNT_DESCENDING': 'Liczba rejestracji (od największej)',
  'REGISTERED_PLAYER_COUNT_ASCENDING': 'Liczba rejestracji (od najmniejszej)'
};



// WEBPACK FOOTER //
// ./utils/tournaments.js